import { spreadAndtransformDefaultValues } from '@common/components/forms';
import { Pager } from '@common/components/pagination';
import { useApp } from '@common/hooks';
import { IHospitalOrganizationsSearchFilter } from '@hospital/stores';
import { observer } from "mobx-react";
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { UserLocationsAddStore } from './UserLocationsAddStore';
import { UserLocationsAddTable } from './UserLocationsAddTable';
import { UserStore } from './UserStore';

interface IUserLocationsAddProps {
    userStore: UserStore;
    onClose: () => void;
}
export const UserLocationsAdd = observer(({ onClose, userStore }: IUserLocationsAddProps) => {
    const { configuration } = useApp();
    const [userLocationsAddStore] = useState<UserLocationsAddStore>(new UserLocationsAddStore({ configuration, userStore }));
    const { register: registerSearch, handleSubmit: handleSubmitSearch, reset: resetSearch } = useForm<IHospitalOrganizationsSearchFilter>({
        shouldFocusError: true,
        defaultValues: spreadAndtransformDefaultValues(userLocationsAddStore.hospitalOrgSearchStore.searchFilter)
    });

    const submitCaller = handleSubmitSearch(d => {
        userLocationsAddStore.hospitalOrgSearchStore.updateSearchFilter({ searchterm: d.searchterm })
    });

    const resetSearchForm = useCallback(() => {
        resetSearch();
        userLocationsAddStore.clear();
    }, [userLocationsAddStore, resetSearch]);

    const close = () => {
        resetSearchForm();
        onClose();
    }

    useEffect(() => {
        userLocationsAddStore.hospitalOrgSearchStore.search();
    }, [userLocationsAddStore.hospitalOrgSearchStore, userLocationsAddStore.hospitalOrgSearchStore.combinedSearchParams, userLocationsAddStore.userStore.user]);

    const saveSelectedOrganizations = () => {
        userStore.addOrganizations(userLocationsAddStore.selectedOrganizations).then(close);
    }


    return (
        <Modal size="xl" centered scrollable backdrop="static" keyboard={false} show={true} onHide={close}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Assign Hospitals To: {userStore.user.firstName + ' ' + userStore.user.lastName}
                </Modal.Title>
            </Modal.Header>
            <Form className="m-3" onSubmit={submitCaller}>
                <div className="d-xl-flex flex-xl-row m-xl-1 justify-content-center align-items-center p-0">
                    <div className="d-flex flex-fill flex-column flex-xl-row justify-content-center align-items-center">
                        <Form.Label className="mb-xl-0 me-xl-2 text-center">Search: </Form.Label>
                        <Form.Control className="me-xl-2 flex-fill flex-grow-1" type="text" id="userLocation_orgSearch" {...registerSearch('searchterm')} />
                        <div className="d-xl-flex text-xl-center pt-3 justify-content-xl-center align-items-xl-center p-xl-0" >
                            <Button className="btn btn-primary flex-xl-grow-1 me-2" type="submit">Search</Button>
                            <Button className="btn btn-secondary btn-outline-primary flex-xl-grow-1" onClick={resetSearchForm}>Clear</Button>
                        </div>
                    </div>
                </div>
            </Form>
            <div className="modal-body">
                <UserLocationsAddTable userLocationsAddStore={userLocationsAddStore} />
            </div>
            <Modal.Footer>
                {
                    userLocationsAddStore.hospitalOrgSearchStore.hasMultiplePages &&
                    <Pager
                        skip={userLocationsAddStore.hospitalOrgSearchStore.searchParams.skip}
                        totalItems={userLocationsAddStore.hospitalOrgSearchStore.searchResults.totalRecordCount}
                        pageSize={userLocationsAddStore.hospitalOrgSearchStore.searchParams.top}
                        onPageChange={userLocationsAddStore.hospitalOrgSearchStore.changePage} />
                }
                <Button className="btn btn-lg btn-secondary btn-outline-primary" onClick={close}>{userLocationsAddStore.selectedOrganizations.length > 0 ? 'Cancel' : 'Close'}</Button>
                <Button className="btn btn-lg btn-primary" onClick={saveSelectedOrganizations}>Add Selected Locations</Button>
            </Modal.Footer>
        </Modal>
    )
});
